import React from "react";
import { useAuth } from "../context/AuthProvider";
import { useNavigate } from "react-router-dom";

const AccountPage = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  // Redirect if not logged in
  if (!user) {
    navigate("/auth");
    return null;
  }

  return (
    <div className="bg-gray-50 min-h-screen py-10 flex flex-col items-center">
      <div className="bg-white w-full max-w-md rounded-2xl shadow-xl p-6">
        <div className="flex items-center space-x-4 mb-8">
          <div className="w-16 h-16 rounded-full bg-gradient-to-br from-amber-400 to-rose-200 flex items-center justify-center text-3xl font-bold text-white">
            {user.name?.charAt(0) || user.phone?.slice(-2) || "U"}
          </div>
          <div>
            <h2 className="text-xl font-semibold">{user.name || "Account"}</h2>
            <p className="text-gray-500 text-sm">{user.phone}</p>
            {user.email && <p className="text-gray-500 text-sm">{user.email}</p>}
          </div>
        </div>
        <div className="divide-y">
          <button
            className="w-full py-3 flex items-center text-lg font-medium hover:bg-gray-100 rounded-lg transition"
            onClick={() => navigate("/account/edit")}
          >
            Edit Profile
          </button>
          <button
            className="w-full py-3 flex items-center text-lg font-medium hover:bg-gray-100 rounded-lg transition"
            onClick={() => navigate("/account/addresses")}
          >
            Manage Addresses
          </button>
          <button
            className="w-full py-3 flex items-center text-lg font-medium hover:bg-gray-100 rounded-lg transition"
            onClick={() => navigate("/my-orders")}
          >
            My Orders
          </button>
          <button
            className="w-full py-3 flex items-center text-lg font-medium hover:bg-gray-100 rounded-lg transition text-rose-500"
            onClick={logout}
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountPage;
